import api from './api';

export interface VariableMetadataItem {
  name: string;
  label: string;
  source?: 'contact' | 'account' | 'agent' | 'ticket';
}

export interface CustomVariableItem {
  name: string;
  label: string;
  default_value?: string;
}

export interface WhatsAppVariableMetadata {
  system_variables: VariableMetadataItem[];
  // What the Digital Companion agent-notify flow actually sends
  // (ticketing_service.py::notify_agent_assigned_async) — kept separate
  // from system_variables so the picker can label the group distinctly.
  ticket_variables?: VariableMetadataItem[];
  custom_variables: CustomVariableItem[];
}

export async function fetchWhatsAppVariableMetadata(accountId: number): Promise<WhatsAppVariableMetadata> {
  const res = await api.get('/whatsapp/variable-metadata', { params: { account_id: accountId } });
  return res.data;
}
